import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import { GenericGridRowData } from '../GenericGrid/Interfaces';

// VtxTable Notes
//
//  key: Unique value for Column (string) - Optional
//  title: Header name of Column (string) - Required
//  dataIndex: Property in GridRowData to display (string) - Required
//  fixed: Column Pinning.  Pinned Columns does not Scroll ('left' | 'right')
//  width: Fixed Colun Width (number)
//  sorter: Can Column be Sorted (boolean)
//  render: Renders the Column Value. Value or Function (string | number | (value: any, row: GridRowData, index: number) => JSX.Element)
//
//  Sorting
//  sorter?: boolean | Sort Function
//  sortOrder?: SortOrder;
//  defaultSortOrder?: SortOrder;
//  sortDirections?: SortOrder[];
//  showSorterTooltip?: boolean;
//
//  Filtering
//  filtered?: boolean;
//  filters?: ColumnFilterItem[];
//  filterDropdown?: React.ReactNode | ((props: FilterDropdownProps) => React.ReactNode);
//  filterMultiple?: boolean;
//  filteredValue?: Key[] | null;
//  defaultFilteredValue?: Key[] | null;
//  filterIcon?: React.ReactNode | ((filtered: boolean) => React.ReactNode);
//  onFilter?: (value: string | number | boolean, record: RecordType) => boolean;
//  filterDropdownVisible?: boolean;
//  onFilterDropdownVisibleChange?: (visible: boolean) => void;

// The Custom Columns will be merge into the Default Columns using the the 'dataIndex' property
// Only specify Column Properties you want to Add / Override in the Default Column Properties
function mergeDefaultAndCustomColumns(
  defaultColumns: VtxColumnProps<GenericGridRowData>[],
  customColumns: VtxColumnProps<GenericGridRowData>[],
): VtxColumnProps<GenericGridRowData>[] {
  // Copy the Default Columns
  const mergedColumns: VtxColumnProps<GenericGridRowData>[] = defaultColumns.slice();

  // Loop through all the Custom Columns
  customColumns.forEach((customColumn:VtxColumnProps<GenericGridRowData>) => {
    // Find the corresponding Default Column
    const defaultColumnIndex: number = defaultColumns.findIndex((column) => (column.dataIndex === customColumn.dataIndex));

    // Default Column was found.  Merge the content of the Default and Custom columns
    if (defaultColumnIndex !== -1) {
      // Merge the Default and Custom Properties
      mergedColumns[defaultColumnIndex] = { ...defaultColumns[defaultColumnIndex], ...customColumn };
    } else {
      // Default Column was NOT found.  Append the Custom column
      mergedColumns.push(customColumn);
    }
  });

  return mergedColumns;
}

export default mergeDefaultAndCustomColumns;
